<template>
    <div class="containerInner">
        <div class="smaregiFetchContainer">
            <div class="header">
                <h3>スマレジから店舗売上を取得</h3>
            </div>
            <div class="smaregiFetch_row">
                <span class="smaregiFetch_periodLabel">対象期間</span>
                <datepicker format="yyyy-MM-dd" :language="ja" calendar-class="calendarDate"
                    input-class="inputDate" wrapper-class="dispPeriodInput" placeholder="開始日"
                    v-model="smaregiStartDate"
                    :highlighted="{ includeDisabled: true, ...$store.getters['holidays/datepickerHighlighted'] }"
                    :disabled-dates="{ from: smaregiDisabledFrom }" />
                <span>〜</span>
                <datepicker format="yyyy-MM-dd" :language="ja" calendar-class="calendarDate"
                    input-class="inputDate" wrapper-class="dispPeriodInput" placeholder="終了日"
                    v-model="smaregiEndDate"
                    :highlighted="{ includeDisabled: true, ...$store.getters['holidays/datepickerHighlighted'] }"
                    :disabled-dates="{ to: smaregiStartDate, from: smaregiDisabledFrom }" />
                <Button class="fetchBtn" @click="showSmaregiFetchCheck">スマレジから取得</Button>
            </div>
            <div class="smaregiFetch_option">
                <label>
                    <input type="checkbox" v-model="smaregiWithSummary">
                    <span>取得後に集計まで実行する（画面の数値に反映する）</span>
                </label>
            </div>
            <p class="smaregiFetch_note">※取得には時間がかかる場合があります。</p>
        </div>

        <div class="uploadCsvContainer">
            <div class="header">
                <h3>店舗売上CSVアップロード</h3>
            </div>
            <label for="file">
                <div class="uploadArea" :class="[{ 'drag': isDrag }]" @dragover.prevent="onDrag($event, true)"
                    @dragleave.prevent="onDrag($event, false)" @drop.prevent="onDrop" ref="uploadArea">
                    <div class="info" v-if="files.length == 0">
                        <div>ファイルをドラッグするか、クリックして選択してください。</div>
                        <div>複数可</div>
                    </div>
                    <ul v-if="files.length">
                        <li v-for="file in files" :key="file.id" @click.prevent>
                            <div class="fileIcon">
                                <Icon title="csv">file-document-outline</Icon>
                            </div>
                            <div class="fileName" :title="file.name">{{ file.name }}</div>
                            <div class="fileStatus" v-if="file.error">
                                <button class="btn normal small" v-if="file.error" @click="fileErrors = file.error">
                                    <Icon title="エラー" color="error">alert-outline</Icon>
                                </button>
                            </div>
                            <div class="fileStatus" v-else-if="file.progress > 0">{{ file.progress }}%</div>
                            <div class="fileStatus" v-else-if="file.success">
                                <Icon title="成功" color="success">check-circle-outline</Icon>
                            </div>
                            <div class="fileStatus" v-else-if="file.active">
                                <vue-loaders name="ball-pulse" color="#02AD90" scale="0.5" />
                            </div>
                            <div class="fileStatus" v-else></div>
                        </li>
                    </ul>
                </div>
            </label>


            <div class="actionsInner">
                <div class="actions">
                    <file-upload :custom-action="action" extensions="csv" accept="text/csv" :multiple="true"
                        :drop="$refs.uploadArea" :drop-directory="true" v-model="files" @input-filter="inputFilter"
                        ref="upload">
                    </file-upload>

                    <button type="button" class="btn btn-success" @click.prevent="$refs.upload.active = true">
                        アップロード
                    </button>
                    <button type="button" class="btn btn-danger" @click.prevent="$refs.upload.clear()">
                        リセット
                    </button>
                </div>
            </div>


            <modal class="uploadCsvError" name="uploadCsvError" :draggable="false" :resizable="false" :scrollable="true"
                width="800" height="auto" @closed="onFileErrorsClosed">
                <div class="header">
                    <h3>{{ fileErrorTitle }}</h3>
                    <a class="btn close" @click="$modal.hide('uploadCsvError')"></a>
                </div>
                <div class="content">
                    <div v-if="defaultFileErrorMessage">
                        {{ defaultFileErrorMessage }}
                    </div>
                    <ul v-else>
                        <li v-for="(fileError, index) in fileErrors" :key="index">
                            <div class="errorRowIndex">
                                <template v-if="fileError.row_index != 0">
                                    {{ fileError.row_index }}行目
                                </template>
                            </div>
                            <ul>
                                <li v-for="(error, index) in fileError.error" :key="index">
                                    {{ error }}
                                </li>
                            </ul>
                        </li>
                    </ul>
                </div>
            </modal>


            <modal class="uploadCsvError" name="uploadCsvCheck" :draggable="false" :resizable="false"
                :scrollable="false" :clickToClose="false" width="500" height="auto">
                <div class="modalHeader">
                    <h3>取込済みの日付のデータが含まれています。<br>すべて更新しますか？</h3>
                </div>
                <div class="modalBtn">
                    <button type="button" class="btn btn-success" @click="onConfirmClick">はい</button>
                    <button type="button" class="btn btn-danger" @click="onCancelClick">いいえ</button>
                </div>
            </modal>


            <modal class="uploadCsvError" name="smaregiFetchCheck" :draggable="false" :resizable="false"
                :scrollable="false" :clickToClose="false" width="500" height="auto">
                <div class="modalHeader">
                    <h3>{{ smaregiFetchPeriodLabel }} の店舗売上を<br>スマレジから取得しますか？</h3>
                </div>
                <div class="modalNote">
                    <p>この期間の登録済みの店舗売上は上書きされます。</p>
                    <p v-if="smaregiWithSummary">取得後に集計まで実行します。</p>
                    <p v-else>集計は実行しません。画面の数値は変わりません。</p>
                </div>
                <div class="modalBtn">
                    <button type="button" class="btn btn-success" @click="onSmaregiFetchConfirmClick">はい</button>
                    <button type="button" class="btn btn-danger" @click="closeSmaregiFetchCheck">いいえ</button>
                </div>
            </modal>
        </div>

        <div class="loading-window" v-show="this.$store.state.loading">
            <div class="loading-window-inner">
                <vue-loaders name="ball-spin-fade-loader" color="#02AD90" scale="1"></vue-loaders>
            </div>
        </div>
    </div>
</template>

<script>
import FileUpload from 'vue-upload-component'
import Datepicker from 'vuejs-datepicker'
import { ja } from 'vuejs-datepicker/dist/locale'

//エラー一覧モーダルの既定の見出し（CSVアップロード経路）
const DEFAULT_FILE_ERROR_TITLE = 'CSVエラー';

export default {
    components: {
        FileUpload,
        Datepicker,
    },
    data() {
        return {
            isDrag: false,
            files: [],
            fileErrors: null,
            //エラー一覧モーダルの見出し。スマレジ取込のスキップ一覧でも同じモーダルを使い回すため差し替え可能にしている
            fileErrorTitle: DEFAULT_FILE_ERROR_TITLE,
            targetFile: null,
            ja: ja,
            smaregiStartDate: this.$dayjs().startOf('date').subtract(1, 'day').toDate(),
            smaregiEndDate: this.$dayjs().startOf('date').subtract(1, 'day').toDate(),
            //shop_sales_reports に入れただけでは画面の数値は変わらないため既定でON
            smaregiWithSummary: true,
        }
    },
    methods: {
        action: async function (file) {
            this.targetFile = file;

            const formData = new FormData();
            formData.append('file', file.file, file.file.filename || file.name);

            await this.axios.post('/api/sales/tempoCsv', formData)
                .then(async (response) => {
                    //バリデーションエラー
                    if (response.data.status == "error") {
                        // レスポンスからバリデーションエラーメッセージを取得して設定
                        file.error = response.data.data || null;
                        this.$toast.error('CSVアップロードエラー', { timeout: 5000 });
                    }

                    //エラーなし・取込済み日付あり
                    else if (response.data.status == "check") {
                        //確認モーダル表示
                        //await → 処理が終わるまで待つ
                        await this.confirmUpdatePromise();
                    }

                    //エラーなし・新規日付のみ
                    else {
                        //更新処理実行
                        await this.confirmUpdate();
                    }
                })
                .catch(error => {
                    file.error = error.response.data.errors.file || null;
                    this.$toast.error('CSVアップロードエラー', { timeout: 5000 });
                });
        },
        //確認モーダル表示
        confirmUpdatePromise() {
            return new Promise((resolve, reject) => {
                // resolveとrejectをグローバルまたはコンポーネントレベルの変数に保持
                this.resolveUpdate = resolve;
                this.rejectUpdate = reject;

                //表示
                this.$modal.show('uploadCsvCheck');
            });
        },

        //確認モーダルで「はい」をクリックしたとき
        async onConfirmClick() {
            //更新処理実行
            await this.confirmUpdate();

            //モーダル閉じる
            this.$modal.hide('uploadCsvCheck');
            this.resolveUpdate();
        },

        //確認モーダルで「いいえ」をクリックしたとき
        async onCancelClick() {
            //更新処理実行
            await this.confirmUpdateNo();

            //モーダル閉じる
            this.$modal.hide('uploadCsvCheck');
            this.resolveUpdate();
        },

        //更新処理（取込済み日付上書きモード）
        confirmUpdate: async function () {
            this.$modal.hide('uploadCsvCheck');

            const formData = new FormData();
            formData.append('file', this.targetFile.file, this.targetFile.file.filename || this.targetFile.name);

            await this.axios.post('/api/sales/confirmTempoCsv', formData)
                .then(response => {
                    if (response.data != "") {
                        this.targetFile.error = response.data.data || null;
                        this.$toast.error('CSVアップロードエラー', { timeout: 5000 });
                    }
                })
                .catch(error => {
                    this.targetFile.error = error.response.data.errors.file || null;
                    this.$toast.error('CSVアップロードエラー', { timeout: 5000 });
                });
        },

        //更新処理（取込済み日付無視モード）
        confirmUpdateNo: async function () {
            this.$modal.hide('uploadCsvCheck');

            const formData = new FormData();
            formData.append('file', this.targetFile.file, this.targetFile.file.filename || this.targetFile.name);

            await this.axios.post('/api/sales/confirmTempoCsvNo', formData)
                .then(response => {
                    if (response.data != "") {
                        this.targetFile.error = response.data.data || null;
                        this.$toast.error('CSVアップロードエラー', { timeout: 5000 });
                    }
                })
                .catch(error => {
                    this.targetFile.error = error.response.data.errors.file || null;
                    this.$toast.error('CSVアップロードエラー', { timeout: 5000 })
                });
        },

        //ファイルアップロード関連処理
        inputFilter: function (newFile, oldFile, prevent) {
            if (newFile && !oldFile) {
                if (!/\.(csv)$/i.test(newFile.name)) {
                    return prevent()
                }
            }
        },
        onDrag: function (event, status) {
            if (status && event.dataTransfer.types == 'text/plain') {
                // ファイルではなく、html要素をドラッグしてきた時は処理を中止
                return false
            }
            this.isDrag = status;
        },
        onDrop: function () {
            this.isDrag = false;
        },

        //スマレジ取得の確認モーダルを開く（既存データを上書きするため必ず一度確認する）
        showSmaregiFetchCheck() {
            this.$modal.show('smaregiFetchCheck');
        },

        //スマレジ取得の確認モーダルを閉じる
        closeSmaregiFetchCheck() {
            this.$modal.hide('smaregiFetchCheck');
        },

        //確認モーダルで「はい」を押したとき
        onSmaregiFetchConfirmClick() {
            this.$modal.hide('smaregiFetchCheck');
            this.executeSmaregiFetch();
        },

        //スマレジから店舗売上を取得する
        executeSmaregiFetch() {
            const params = {
                start_day: this.$dayjs(this.smaregiStartDate).format('YYYY-MM-DD'),
                end_day: this.$dayjs(this.smaregiEndDate).format('YYYY-MM-DD'),
                with_summary: this.smaregiWithSummary,
            };
            //取得完了までローディング表示を出しておく（モーダルは完了後に閉じる）
            this.$store.dispatch("loading", true);
            this.axios.post('/api/sales/smaregi', params)
                .then((response) => {
                    const skipped = response.data.skipped ?? 0;
                    const unknownStores = response.data.unknown_stores ?? {};
                    const unknownStoreCodes = Object.keys(unknownStores);

                    //取り込めなかった行（イレギュラー対応コード等）と、
                    //pochi に未登録でまるごと取り込めなかった店舗を、既存のエラー一覧モーダルにまとめて出す
                    if (skipped > 0 || unknownStoreCodes.length > 0) {
                        this.fileErrorTitle = 'スマレジ取込 未取込一覧';

                        const rows = unknownStoreCodes.map(code => ({
                            row_index: 0,
                            error: [`店舗コード:${code} ${unknownStores[code]} → pochi に未登録のため取り込めませんでした（設定 > 店舗コード設定に登録してください）`],
                        }));

                        this.fileErrors = rows.concat((response.data.skipped_rows ?? []).map(r => ({
                            //取込元に行番号の概念が無いため0を入れる（0のときは行番号を表示しない）
                            row_index: 0,
                            error: [`${r.date} 店舗:${r.store_code} 商品:${r.product_name} 品番:${r.supplier_product_no} → ${r.reason}`],
                        })));

                        if (unknownStoreCodes.length > 0) {
                            this.$toast.error(`pochi に未登録の店舗が ${unknownStoreCodes.length} 件あります。この店舗の売上は取り込まれていません。`);
                        }

                        if (skipped > 0) {
                            this.$toast.error(`${skipped} 件をスキップしました。スマレジ側の取引履歴を確認してください。`);
                        }
                    } else {
                        //集計まで走ったかどうかで文言を変える（集計しないと画面の数値は変わらないため）
                        const summaryNote = response.data.summarized
                            ? '集計まで完了しました。'
                            : '集計は実行していないため、画面の数値はまだ変わりません。';
                        this.$toast.success(`スマレジから ${response.data.fetched} 件取り込みました。${summaryNote}`);
                    }
                }).catch(error => {
                    //500系・422 は axios の interceptor がトーストを出すので二重に出さない。
                    //ただしタイムアウトやネットワーク断はレスポンスが無く interceptor が拾えないため、ここで補う。
                    if (!error.response) {
                        this.$toast.error('通信に失敗しました。時間をおいて再度お試しください。');
                    }
                }).finally(() => {
                    this.$store.dispatch("loading", false);
                });
        },

        //エラー一覧モーダルを閉じたとき（見出しをCSV用の既定値に戻す）
        onFileErrorsClosed() {
            this.fileErrors = null;
            this.fileErrorTitle = DEFAULT_FILE_ERROR_TITLE;
        },
    },
    watch: {
        fileErrors: function (v) {
            if (v) {
                this.$modal.show('uploadCsvError')
            }
        },
        //開始日が終了日より後になった場合、終了日を開始日に合わせる
        smaregiStartDate: function (date) {
            if (date > this.smaregiEndDate) {
                this.smaregiEndDate = date;
            }
        },
    },
    computed: {
        defaultFileErrorMessage: function () {
            if (Array.isArray(this.fileErrors)) {
                return null
            }
            // FileUpload defaule error
            //   size, extension, timeout, abort, network, server, denied
            const errors = {
                size: 'サイズオーバー',
                extension: '拡張子が違います',
            }
            return errors[this.fileErrors] ?? `${this.fileErrors}エラー`
        },

        //スマレジ取得 開始日・終了日の選択可能上限（昨日まで）
        //disabled-dates の from は「fromより後」を無効にするため、昨日を渡して今日以降を無効にする
        smaregiDisabledFrom: function () {
            return this.$dayjs().startOf('date').subtract(1, 'day').toDate();
        },

        //確認モーダルに出す対象期間（何日分を取り直すのか目で確かめられるようにする）
        smaregiFetchPeriodLabel: function () {
            const start = this.$dayjs(this.smaregiStartDate).format('YYYY-MM-DD');
            const end = this.$dayjs(this.smaregiEndDate).format('YYYY-MM-DD');
            return start === end ? start : `${start} 〜 ${end}`;
        },
    },
}
</script>


<style scoped lang="sass">
.containerInner
    overflow: hidden
    text-align: center
    .uploadCsvContainer
        position: relative
        padding: 15px
        width: 50%
        display: inline-grid
        grid-template-columns: 1fr
        grid-template-rows: 57px 1fr 50px
        .header
            overflow: hidden
            padding: 5px
            h3
                display: block
                float: left
                padding: 10px
                font-size: 1.7rem
        .modalHeader
            overflow: hidden
            padding: 5px
            h3
                display: block
                padding: 10px
                font-size: 1.7rem
        .uploadArea
            padding: 1em
            background: $whiteColor
            border-style: dashed
            border-width: 3px
            border-color: $grayColor
            border-radius: 1em
            height: 300px
            cursor: pointer
            overflow: scroll
            &.drag
                background: #e0f2f1
                border-color: $mainColor
            .info
                position: absolute
                top: 100px
                width: 100%
                text-align: center
                font-size: 1.5em
                color: #666
                div
                    margin-bottom: 1em
            ul
                li
                    text-align:  left
                    align-items: center
                    margin: 2px
                    padding: 5px
                    width: 100%
                    height: 50px
                    background: #f5f5f5
                    border: 1px solid $mainColor
                    display: inline-grid
                    grid-template-columns: 50px 1fr 100px
                    grid-template-rows: 1fr
                    cursor: default
                    div
                        font-size: 1.5em
                        white-space: nowrap
                        overflow: hidden
                        text-overflow: ellipsis
                        vertical-align: middle
                        &.fileIcon
                            text-align: center
                        &.fileName
                            line-height: 1.5em
                        &.fileStatus
                            text-align: center
        .actionsInner
            margin-top: 50px
            .actions
                display: flex
                flex-direction: row
                gap: 20px
                justify-content: center
                .file-uploads
                    display: none
        .btn-danger
            background-color: #ccc
            border: 1px solid #ccc
            color: #000
        .uploadCsvError
    .header
        h4
            float: left
            font-size: 1.7rem
        .close
            float: right
    .content
        padding: 1em
        font-size: 1.5em
        > div
            margin: 2px
            padding: 10px 20px
            width: 100%
            background: #f5f5f5
            border: 1px solid $grayColor
        > ul > li
            align-items: start
            margin: 2px
            padding: 10px 5px
            width: 100%
            background: #f5f5f5
            border: 1px solid $grayColor
            display: inline-grid
            grid-template-columns: 150px 1fr
            grid-template-rows: 1fr
            > div
                padding-left: 10px
                padding-right: 30px
            > ul > li
                margin-top: 15px
                &:first-of-type
                    margin-top: 0
    .modalNote
        padding: 0 20px
        text-align: center
        font-size: 1.4rem
    .modalBtn
        display: flex
        flex-direction: row
        gap: 20px
        margin: 20px 0
        justify-content: center
.smaregiFetchContainer
    position: relative
    padding: 15px
    width: 50%
    // .uploadCsvContainer が inline-grid のため、inline 系にすると横に並んでしまう。
    // block + margin auto で上下に積み、幅50%を保って左端を揃える。
    display: block
    margin: 0 auto
    text-align: left
    color: $grayColor
    .header
        overflow: hidden
        padding: 5px
        h3
            display: block
            float: left
            padding: 10px
            font-size: 1.7rem
    .smaregiFetch_row
        display: flex
        flex-wrap: wrap
        align-items: center
        gap: 8px
        padding: 0 10px
        font-size: 1.4rem
        .smaregiFetch_periodLabel
            font-size: 1.4rem
        // vuejs-datepicker が生成する input は子コンポーネントの内部要素のため
        // scoped スタイルが届かない。App.vue の .inputDate には font 指定が無く
        // ブラウザ既定のままだと周囲の文字より小さく別フォントになるので、ここで揃える。
        ::v-deep .inputDate
            font-size: 1.4rem
            font-family: inherit
            width: 110px
            padding: 6px
        .fetchBtn
            margin-left: 10px
    .smaregiFetch_option
        padding: 10px 10px 0
        font-size: 1.4rem
        label
            display: inline-flex
            align-items: center
            gap: 6px
            cursor: pointer
    .smaregiFetch_note
        padding: 8px 10px 0
        font-size: 1.4rem
.loading-window
    background: rgba(255, 255, 255, 0.8)
    height: 100%
    left: 0
    position: fixed
    top: 0
    width: 100vw
    // モーダルより手前に表示する
    z-index: 2000
    .loading-window-inner
        left: 50%
        position: absolute
        text-align: center
        top: 50%
        transform: translate(-50%, -50%)
</style>
